import React, {useState} from 'react';
import './Homepage.css'
import Burger from './Hamburger.js'
import MobileNavBar from './MobileNavBar.js'

import Kaitlin from '../Images/Homepage/KaitlinYang_Header.jpg'
import Bio from '../Images/Homepage/BIO.jpg'
import Homepage1 from '../Images/Homepage/HOMEPAGE_1.jpg'
import Homepage2 from '../Images/Homepage/HOMEPAGE_2.jpg'
import Homepage3 from '../Images/Homepage/HOMEPAGE_3.jpg'


export default function About(){
	const [open, setOpen] = useState(false);

	return(
		<div>
			<div class="homepageSection">
				<img class="homepageImage" src={Kaitlin} />
				<img class="homepageImage" src={Bio} />
				<div class="homepageGrid">
					<img class="gridImage" src={Homepage1} />
					<img class="gridImage" src={Homepage2} />
					<img class="gridImage" src={Homepage3} />

				</div>
			</div>

			<div className="homepage-mobile">
				<div className="mobileNav">
					<Burger open={open} setOpen={setOpen}/>
					<MobileNavBar open={open} setOpen={setOpen}/>
				</div>
				<div className="mobileContent">
					<img className="mobileImage" src={Kaitlin} loading="lazy"/>
					<img className="mobileImage" src={Bio} loading="lazy"/>
					<img className="mobileImage" src={Homepage1} loading="lazy"/>
					<img className="mobileImage" src={Homepage2} loading="lazy"/>
					<img className="mobileImage" src={Homepage3} loading="lazy"/>
				</div>
			</div>
		</div>
	)
}
